import { ErrorMessage, useField } from "formik"
import styles from './MyTextInput.module.css'

export const MyTextInput66 = ({ label, mode="vertical", ...props }) => {

  const [field] = useField(props)

  return <>
    {
      mode === "horizontal" &&
      <div className="mb-3 row">
        <label className='col-form-label col-6' htmlFor={props.id || props.name} >{label}</label>
        <div className="col-6">
          <input className="form-control" type="text" {...field} {...props} />
          <ErrorMessage name={props.name} component="span" className={styles.errorMessage} />
        </div>        
      </div>
    }
    {
      mode === "vertical" &&
      <div className="mb-3">
        <label className='form-label' htmlFor={props.id || props.name} >{label}</label>
        <input className="form-control" type="text" {...field} {...props} />
        <ErrorMessage name={props.name} component="span" className={styles.errorMessage} />
      </div>
    }
  </>
}
